function getDefaultDocs() {
  return {
    privacyPolicy: {
      url: "",
      fileName: "",
    },
  };
}

function normalizePrivacyPolicy(raw) {
  const source = raw && typeof raw === "object" ? raw : {};
  return {
    url: String(source.url || "").trim(),
    fileName: String(source.fileName || "").trim(),
  };
}

function normalizeData(raw) {
  if (!raw || typeof raw !== "object") return getDefaultDocs();
  return {
    privacyPolicy: normalizePrivacyPolicy(raw.privacyPolicy),
  };
}

function getDocsData() {
  const cached = window.NMApi?.cache?.docs;
  if (cached && typeof cached === "object") return normalizeData(cached);
  return getDefaultDocs();
}

function saveDocsData(data) {
  const normalized = normalizeData(data);
  if (!window.NMApi) return Promise.resolve(normalized);
  window.NMApi.cache.docs = normalized;
  return window.NMApi.save("docs", normalized);
}

function getPrivacyPolicyUrl() {
  return getDocsData().privacyPolicy.url || "";
}

function applyPolicyLinks() {
  const url = window.NMSanitize?.safeHref?.(getPrivacyPolicyUrl()) || "";
  document.querySelectorAll("[data-policy-link], a.footer__policy").forEach((node) => {
    const link = node;
    const isFooter = link.classList.contains("footer__policy");
    if (url) {
      link.hidden = false;
      link.style.display = "";
      link.style.pointerEvents = "";
      link.style.cursor = "";
      link.style.textDecoration = "";
      link.style.color = "";
      link.setAttribute("href", url);
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
      return;
    }
    link.removeAttribute("href");
    link.removeAttribute("target");
    link.removeAttribute("rel");
    if (isFooter) {
      link.hidden = true;
      link.style.display = "none";
      return;
    }
    // В формах оставляем текст, но без перехода на /policy-page
    link.hidden = false;
    link.style.display = "";
    link.style.pointerEvents = "none";
    link.style.cursor = "text";
    link.style.textDecoration = "none";
    link.style.color = "inherit";
  });
}

function redirectPolicyPageIfNeeded() {
  if (!document.querySelector(".policy-page")) return;
  const url = getPrivacyPolicyUrl();
  if (url) {
    window.location.replace(url);
    return;
  }
  window.location.replace("/");
}

let docsHydrated = false;
function hydratePublicDocs() {
  applyPolicyLinks();
  if (docsHydrated) return;
  docsHydrated = true;
  redirectPolicyPageIfNeeded();
}

window.NMDocsContent = {
  getDefaultDocs,
  normalizeData,
  getDocsData,
  saveDocsData,
  getPrivacyPolicyUrl,
  applyPolicyLinks,
  hydratePublicDocs,
};

window.NMApi?.ready?.then(hydratePublicDocs);
